var render = function render(_c,_vm){return _c('section',{class:[_vm.data.staticClass, _vm.data.class]},[_vm._t("header"),(_vm.slots().default)?_c('div',{staticClass:"container my-3"},[_vm._t("default")],2):_vm._e(),_vm._t("full")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }